export default "__VITE_ASSET__sKkuFkQ9__"